import { gql } from "@apollo/client";

const LIST_PROCESS_CALENDAR = gql`query ListProcessCalendar ($periodUid: UUID!, $userUids: [UUID!]!) {
  allCalendarProcesses(
    filter: { 
      periodUid: {equalTo: $periodUid}
      userUid: {in: $userUids}
    }
    orderBy: CREATED_AT_DESC
  ) {
    nodes {
      comment
      createdAt
      userUid
      userByCreatedBy {
        firstName
        lastName
      }
      userByUserUid {
        lastName
        firstName
      }
      calendarState
    }
  }
}`;

const CREATE_CALENDAR_PROCESS = gql`mutation CreateCalendarProcess($userUid: UUID!, $calendarState: CalendarState!, $periodUid: UUID!, $comment: String) {
  createCalendarProcess(
    input: {calendarProcess: {userUid: $userUid, periodUid: $periodUid, calendarState: $calendarState, comment: $comment}}
  ) {
    calendarProcess {
      comment
      calendarState
    }
  }
}`;

const STATS_PROCESS_CALENDAR = gql`query StatsProcessCalendar($periodUid: UUID!, $userUids: [UUID!]!, $classroomUids: [UUID!]!) {
  wait_super_admin: allCalendarProcesses(
    filter: {calendarState: {equalTo: WAITTING_SUPER_ADMIN}, periodUid: {equalTo: $periodUid}, userUid: {in: $userUids}}
  ) {
    totalCount
  }
  wait_admin: allCalendarProcesses(
    filter: {calendarState: {equalTo: WAITTING_ADMIN}, periodUid: {equalTo: $periodUid}, userUid: {in: $userUids}}
  ) {
    totalCount
  }
  wait_user: allCalendarProcesses(
    filter: {calendarState: {equalTo: WAITTING_USER}, periodUid: {equalTo: $periodUid}, userUid: {in: $userUids}}
  ) {
    totalCount
  }
  approved: allCalendarProcesses(
    filter: {calendarState: {equalTo: APPROVED}, periodUid: {equalTo: $periodUid}, userUid: {in: $userUids}}
  ) {
    totalCount
  }
  total: allUsers(
    filter: {userRole: {equalTo: HORAROJ_USER}, classroomUid: {in: $classroomUids}}
  ) {
    totalCount
  }
}`;

export {
  LIST_PROCESS_CALENDAR,
  CREATE_CALENDAR_PROCESS,
  STATS_PROCESS_CALENDAR,
};
